import { CalendarMonthOutlined } from '@mui/icons-material';
import {
  Box,
  CardContent,
  CardMedia,
  Chip,
  Stack,
  Typography,
} from '@mui/material';

import { TopicsGlobalScoreData } from '@/domain/impact-calculate/entities/calculate.entity';
import { ProjectAbstract } from '@/domain/project/entities/project.entity';
import FairlyBackgroundLogo from '@/ui/assets/logo-fairly-background.png';
import { FSCard } from '@/ui/components/FSCard';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';
import { formatProjectDatesFromProject } from '@/ui/utils/format-project-dates';
import { getProjectState } from '@/ui/utils/project-state';

import { CardScores } from './CardScores';

interface IProps {
  project: ProjectAbstract;
  topicsGlobalScoreData: TopicsGlobalScoreData;
  onClick: () => void;
}

export function ProjectCard({
  project,
  topicsGlobalScoreData,
  onClick,
}: IProps) {
  return (
    <FSCard onClick={onClick} sx={{ height: '100%' }}>
      <Box sx={{ position: 'relative' }}>
        <Box sx={{ height: 180 }}>
          {project.image ? (
            <CardMedia sx={{ height: 180 }} image={project.image} />
          ) : (
            <CardMedia
              sx={{
                height: 180,
                backgroundColor: ColorsRaw.anthracite.Anthracite_2,
              }}
              image={FairlyBackgroundLogo}
            />
          )}
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            zIndex: 10,
            height: 180,
            width: '100%',
            backgroundImage: `linear-gradient(to bottom, ${ColorsRaw.anthracite.Anthracite_1}40 0%, ${ColorsRaw.anthracite.Anthracite_1}BB 75%, ${ColorsRaw.anthracite.Anthracite_1} 100%)`,
          }}
        ></Box>
        <Stack
          display={'flex'}
          alignItems={'center'}
          direction={'row'}
          spacing={1}
          sx={{ position: 'absolute', top: 120, zIndex: 20, p: 2 }}
        >
          {project.type && (
            <Chip label={translate(`ProjectType.${project.type}`)} />
          )}
          {project.startDate && project.endDate && (
            <Chip label={getProjectState(project)} />
          )}
        </Stack>
      </Box>
      <CardContent>
        <Stack>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {project.name}
          </Typography>
          {project.startDate && project.endDate && (
            <Stack direction={'row'} spacing={1} sx={{ mt: 0.5, mb: 2 }}>
              <CalendarMonthOutlined />
              <Typography sx={{ opacity: 0.7, fontWeight: 600 }}>
                {formatProjectDatesFromProject(project)}
              </Typography>
            </Stack>
          )}
          <CardScores topicsGlobalScoreData={topicsGlobalScoreData} />
        </Stack>
      </CardContent>
    </FSCard>
  );
}
